import React, { useEffect, useState } from "react"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"
import NewPasswordForm from "../../components/Lystface/ForgotPassword/NewPassword/NewPasswordForm"
import withRouter from "../../components/Common/withRouter"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PasswordUpdatedLayout from "../../components/Lystface/Helper/ForgotPassword/PasswordUpdated/PasswordUpdatedLayout"
import { appConstants } from "../../constants/app_constants"
import Loading from "../../components/Common/Loading"
import { userForgetPasswordReset } from "../../store/actions"

const NewPassword = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(userForgetPasswordReset())

    }
  }, [])
  document.title = `New Password | ${appConstants.cName}`

  const [isLoading, setIsLoading] = useState(false)

  const passId = props.router.params.passId

  const ForgetPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    ForgetPasswordState,
    ForgotPassword => ({
      loading: ForgotPassword.loading,
      forgotPasswordErrorMessage: ForgotPassword.forgotPasswordErrorMessage,
      forgotPasswordError: ForgotPassword.forgotPasswordError,
      user: ForgotPassword.user,
      linkSend: ForgotPassword.linkSend,
      passwordUpdate: ForgotPassword.passwordUpdate,
    })
  )
  const { passwordUpdate } = useSelector(ForgotPasswordProperties)


  return (
    <>
      {
        isLoading ?
          <Loading />
          :
          passwordUpdate ?
            <PasswordUpdatedLayout passId={passId} isPasswordUpdated={passwordUpdate} />
            :
            <BackgroundAuthentication isFromNewPwd={true} form={<NewPasswordForm passId={passId} />} />
      }
    </>
  )
}

export default withRouter(NewPassword)
